export const STORAGE_KEY = {
  trackingIconsFilters: 'INSTITUTIONAL-WEB-TRACKING-ICONS-FILTERS',
};
